import { useQuery } from "@tanstack/react-query";
import { fetchCategories } from "../lib/api";
import { registerCustomCategories, allCategories } from "../lib/categories";

// Loads built-in + household custom categories and registers the custom ones into the
// shared category map so getCategory() renders their label + color app-wide.
export const useCategories = () => {
  const { data } = useQuery({ queryKey: ["categories"], queryFn: fetchCategories, staleTime: 60000, retry: false });
  if (data?.custom) registerCustomCategories(data.custom);
  return { all: allCategories(), custom: data?.custom || [], builtin: data?.builtin || [] };
};
